export enum ArticlesMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_ARTICLES = 'SET_ARTICLES',
  SET_SEARCH_ARTICLES = 'SET_SEARCH_ARTICLES ',
  SET_SELECTED_ARTICLE = 'SET_SELECTED_ARTICLE',
  SET_SEARCH = 'SET_SEARCH',
}
